import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const popupService = {
    fetchPopupMessages,
    createPopup,
    updatePopup,
    deletePopup
};

function fetchPopupMessages() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.popupmessage.fetchPopups, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function createPopup(popupDetails) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.popupmessage.createPopup, popupDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updatePopup(popupDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.popupmessage.updatePopup, popupDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function deletePopup(popupId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.popupmessage.deletePopup}/${popupId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}